export function FilledManagerNotificationSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/filled-manager-notification.svg'"></ng-include>`
    }
}